(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zar-affiliate-program"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      const items = section.querySelectorAll('[data-zar-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

      items.forEach((item) => {
        const bounds = item.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) item.classList.add('is-visible');
      });
      section.setAttribute('data-zar-animate', '');
      items.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('.zar-affiliate').forEach((section) => initializeSection(section));

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target.querySelector) return;
      const section = event.target.querySelector('.zar-affiliate');
      if (section) initializeSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
